<template>
  <div
    id="track-seekbar-frame"
    class="
      $color/background:gray:333
      @768/layout/top
      color/background
      layout/absolute
      layout/top
      layout/width:100%
    "
    >
    <div
      class="
        $color/white
        $typography/size:small
        layout/align:center
        layout/flex
        layout/wrapper
      "
      >
      <SpanTime :time="formatSeconds(currentTime)" />
      <TrackSeekbar
        :current-time="currentTime"
        :duration="duration"
        @click-to="onClickTo"
        @scrub-to="onScrubTo"
      />
      <SpanTime :time="formatSeconds(remainingTime)" />
    </div>
  </div>
</template>

<script>
  import TrackSeekbar from './track-seekbar';
  import SpanTime from './span-time';

  export default {
    components: {
      TrackSeekbar,
      SpanTime
    },
    props: {
      currentTime: { type: Number, required: true },
      duration: { type: Number, required: true },
      isPlaying: { type: Boolean, required: true },
      initPlaying: { type: Boolean, required: true },
    },
    data() {
      return {
        remainingTime: 0,
      };
    },
    watch: {
      initPlaying() {
        this.show();
      }
    },
    mounted() {
      this.remainingTime = this.duration;
    },
    methods: {
      onClickTo(data) {
        this.$emit('click-to', { seconds: data.seconds });
      },
      onScrubTo(data) {
        this.$emit('scrub-to', { seconds: data.seconds });
      },
      formatSeconds: function(sec) {
        const minutes = Math.floor(sec / 60);
        let seconds = Math.floor(sec % 60);
        if (seconds < 10) seconds = `0${seconds}`;

        return minutes + ":" + seconds;
      },
      show() {
        const seekbarEl = this.$el.querySelector('[data-track-seekbar]');
        const styles = window.getComputedStyle(seekbarEl);
        const heightDesktop = styles.getPropertyValue('--768--layout--height');
        const heightMobile = styles.getPropertyValue('--layout--height');

        this.$el.setAttribute(
          'style',
          `
            --768--layout--top: -${heightDesktop};
            --layout--top: -${heightMobile};
          `
        );
      }
    },
  };
</script>
